import { Modal } from "flowbite-react";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { createSupplier } from "../../../../common/services/supplier.api";
import FormCreateSupplier from "../form/FormCreateSupplier";

type Props = {
  onClose?: () => void;
};

export default function ModalCreateSupplier(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();

  const handleCloseModal = () => {
    if (props.onClose) {
      props.onClose();
    }
  };

  async function handleSubmit(dataToSave) {
    try {
      const result = await createSupplier(dataToSave);

      const { ok } = result;
      if (ok) {
        notifySuccess("Fornecedor cadastrado!");
        handleCloseModal(); 
      } else {
        notifyError(result.message as string);
      }
    } catch (err) {
      console.log(err);
      notifyError((err as Error).message);
    }
  }

  return (
    <Modal show={true} onClose={handleCloseModal}>
      <Modal.Header className="text-black">
        <h2 className="text-black">Novo fornecedor</h2>
      </Modal.Header>
      <Modal.Body className="text-black">
        <FormCreateSupplier onSubmit={handleSubmit} />
      </Modal.Body>
    </Modal>
  );
}
